import { RiArrowUpDownLine } from "react-icons/ri";
import "./index.css";
import { useEffect, useState } from "react";
import Select from "react-select";
import {customStyle} from "./selectStyle";
import { convertURLParamsToObject, handleInput, objectToURLParams, showMessageError } from "../../classes/functions";
import api from "../../config";
import SelectColumns from "./SelectColumns";

export default function Table({tableName, data, defaultTableValues, sortingProperties, functions, filters, getList, selects}){
    const [tableConfigIsOpen, setTableConfigIsOpen] = useState(false);
    const [headersOptions, setHeadersOptions] = useState([]);
    const [draggedColumn, setDraggedColumn] = useState(undefined);
    const [indexOfHoveredColumn, setIndexOfHoveredColumn] = useState(1);

    function changeOrderAndItemOfSorting(currentIndex){
        if(sortingProperties.state.order === "ASC"){
            sortingProperties.setState((prevState) => ({...prevState, order: "DESC"}));
        } else{
            sortingProperties.setState((prevState) => ({...prevState, order: "ASC"}));
        }

        sortingProperties.setState((prevState) => ({...prevState, item: headersOptions[currentIndex]?.index}));
        setTableValues();
        getList();
    }
    
    function changeColumnsTablePositions(event, index){
        event.preventDefault();

        const draggedColumnBeforeChange = {header: headersOptions[draggedColumn]?.label, index: headersOptions[draggedColumn]?.index};
        const columnChoosedOnDragBeforeChange = {header: headersOptions[index]?.label, index: headersOptions[index]?.index};

        headersOptions[draggedColumn].label = columnChoosedOnDragBeforeChange.header;
        headersOptions[index].label = draggedColumnBeforeChange.header;

        headersOptions[draggedColumn].index = columnChoosedOnDragBeforeChange.index;
        headersOptions[index].index = draggedColumnBeforeChange.index;

        setHeadersOptions(headersOptions);
        setDraggedColumn(-1);
    }

    function setTableValues(){
        const data = {table: tableName, columns: headersOptions};

        api
        .put(`/api/table/${tableName}`, data)
        .then((response) => {})
        .catch((error) => {
            console.log(error);
            showMessageError(error?.response?.message);
        })
    }

    function getTableValues(){
        let data = [];

        api
        .get(`/api/table/${tableName}`)
        .then((response) => {
            if(response?.data?.length > 0){
                data = response?.data;

                setHeadersOptions(response?.data);    
            }
        })
        .catch((error) => {
            console.log(error);
            showMessageError(error?.response?.message);
        })
        .finally(() => {
            if(data?.length === 0){
                setHeadersOptions(defaultTableValues);
            }
        });
    }

    function checkWhatMustBeInColumnHeader(currentHeader, index){
        let hasOptions = selects?.filter((select) => select.index === currentHeader.index)[0];
        let hasModal = functions?.filter((func) => func.index === currentHeader?.index)[0];
        
        if(currentHeader?.label === "Saldo"){
            return (
                <div className="table____header-info">
                    <div style={{display: "flex", gap: "0.5rem", alignItems: "center"}}>
                        <div draggable onDragStart={() => setDraggedColumn(index)} onDragOver={(e) => e.preventDefault()} onDrop={(e) => changeColumnsTablePositions(e, index)}><span className="table____header-label">{currentHeader?.label}</span></div>
                        <button draggable onDragStart={() => setDraggedColumn(index)} onDragOver={(e) => e.preventDefault()} onDrop={(e) => changeColumnsTablePositions(e, index)}><RiArrowUpDownLine onClick={() => changeOrderAndItemOfSorting(index)} /></button>
                    </div>
                </div>
            )
        }

        return (
            <div className="table____header-info">
                <div draggable onDragStart={() => setDraggedColumn(index)} onDragOver={(e) => e.preventDefault()} onDrop={(e) => changeColumnsTablePositions(e, index)}><span className="table____header-label">{currentHeader?.label}</span></div>
                {(!hasModal && currentHeader.label !== "Saldo" && currentHeader.label !== "Saldo") && <div style={{display: "flex", gap: "0.5rem"}}>
                    {hasOptions?.index &&
                        <div>
                            <Select
                                options={hasOptions?.options}
                                value={filters.state[currentHeader.index]}
                                onChange={(value) => filters.setState((prevState) => ({...prevState, [currentHeader.index]: value}))}
                                styles={customStyle}
                                placeholder={currentHeader.label}
                                menuPosition="fixed"
                                key={index}
                                isMulti
                            />
                        </div>
                    }
                    {!hasOptions?.index &&
                        <input
                            type="text"
                            name={currentHeader.index}
                            className="table____header-info__input"
                            value={filters.state[currentHeader.index]}
                            tableName={currentHeader.index}
                            onChange={(e) => {handleInput(filters.setState, e); changeFiltersInURL()}}
                            placeholder={currentHeader.label}
                            onDragStart={(event) => {event.preventDefault(); event.stopPropagation()}}
                            draggable={false}
                            key={index}
                        />
                    }
                    <button 
                        draggable 
                        onDragStart={() => setDraggedColumn(index)} 
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => changeColumnsTablePositions(e, index)}
                        style={{backgroundColor: "blue"}}
                    ><RiArrowUpDownLine onClick={() => changeOrderAndItemOfSorting(index)} /></button>
                </div>}
            </div>
        )
    }

    function changeFiltersInURL(){
        const filtersToURL = Object.assign({}, filters.state);

        console.log(objectToURLParams(filtersToURL))

        window.history.pushState({}, "", `${window.location.pathname}?${objectToURLParams(filtersToURL)}`);
    }

    function convertFiltersExistingInURLToObject(){
        const convertedURLParamsToObject = convertURLParamsToObject(window.location.search);

        for(let i = 0; i < selects.length; i++){
            if(selects[i]?.options?.length > 0){
                let objectInURLByColumnWithArrayName = convertedURLParamsToObject[selects[i]?.index];

                if(objectInURLByColumnWithArrayName !== undefined){
                    const arrayIsEmpty = (objectInURLByColumnWithArrayName === "");

                    if(arrayIsEmpty){
                        objectInURLByColumnWithArrayName = [];
                    } else{
                        selects[i]?.options?.map((option) => {
                            if(!Array.isArray(objectInURLByColumnWithArrayName)){
                                objectInURLByColumnWithArrayName = objectInURLByColumnWithArrayName?.split(",");
                            }
                            
                            objectInURLByColumnWithArrayName?.map((propertyInURLValue, propertyInURLIndex) => {
                                if(propertyInURLValue == option?.value){
                                    objectInURLByColumnWithArrayName[propertyInURLIndex] = {label: option?.label, value: option?.value};
                                }
                            });
                        });
                    }

                    convertedURLParamsToObject[selects[i]?.index] = objectInURLByColumnWithArrayName;
                }
            }
        }

        filters?.setState(convertedURLParamsToObject);
        
    }
   
    useEffect(() => {
        changeFiltersInURL();
        getList();
    }, [filters.state]);

    useEffect(() => {
        if(draggedColumn){
            setTableValues();
        }
    }, [draggedColumn]);

    useEffect(() => {
        getTableValues();
    }, []);

    useEffect(() => {
      convertFiltersExistingInURLToObject();
    }, []);

    return (
        <div style={{maxWidth: "100%", overflowX: "scroll"}}>
            <SelectColumns 
                headersOptions={{state: headersOptions, setState: setHeadersOptions}} 
                tableConfigIsOpen={{state: tableConfigIsOpen, setState: setTableConfigIsOpen}} 
                setTableValues={setTableValues} 
            />
            <table id="table" style={{marginTop: "2.5rem", width: "100%"}}>
                <thead className="table__header">
                    <tr>
                        {headersOptions.map((currentHeader, index) => {
                            if(currentHeader?.isSelected){
                                return (
                                    <th 
                                        className="table___header-column" 
                                        scope="col" 
                                        key={index} 
                                        style={{backgroundColor: ((indexOfHoveredColumn === index) ? "#f8f8f8" : "")}}
                                        onMouseEnter={() => setIndexOfHoveredColumn(index)}
                                    >
                                        {checkWhatMustBeInColumnHeader(currentHeader, index)}
                                    </th>
                                )
                            }
                        })}
                    </tr>
                </thead>
                <tbody className="table__body">
                    {data.state.map((currentData, index) => {
                        return (
                            <tr key={index}>
                                {headersOptions.map((currentHeader, headerIndex) => {
                                    let hasModal = functions?.filter((func) => func.index === currentHeader?.index)[0];

                                    if(currentHeader?.isSelected){
                                        return (
                                            <td scope="col" key={headerIndex}>
                                                {hasModal 
                                                    ? 
                                                        <button type="button" className="buttonTable" onClick={() => hasModal.function(currentData)}>Ver {hasModal.label}</button>
                                                    :
                                                    currentData[currentHeader.index]
                                                }
                                            </td>  
                                        );
                                    }
                                })}
                            </tr>
                        )
                    })}
                    {data?.state?.length === 0 &&
                        <tr>
                            <td colSpan={headersOptions?.length}><label className='required'>Nenhum registro encontrado!</label></td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
} 